// types
import { filterAppsStateSchema } from "../types/filterAppsTypes";

export const getFilterAppsState = (state: filterAppsStateSchema) =>
  state.filterApps;
